// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import classnames from 'classnames';
// import getGridWidthClass from '../../utils/getGridWidthClass';

// import InputText from '../InputText';
// import InputDateRange from '../InputDateRange';
// import InputMultiSelect from '../InputMultiSelect';
// import InputLabelWrapper from '../InputLabelWrapper';
// import { Icons } from '@ohif/ui-next';

// const InputGroup = ({
//   inputMeta,
//   values,
//   onValuesChange,
//   sorting,
//   onSortingChange,
//   isSortingEnabled,
// }) => {
//   const { sortBy, sortDirection } = sorting;
//   const [isExpanded, setIsExpanded] = useState(false);
//   const handleFilterLabelClick = name => {
//     if (isSortingEnabled) {
//       let _sortDirection = 'descending';
//       if (sortBy === name) {
//         if (sortDirection === 'ascending') {
//           _sortDirection = 'descending';
//         } else if (sortDirection === 'descending') {
//           _sortDirection = 'ascending';
//         }
//       }

//       onSortingChange({
//         sortBy: _sortDirection !== 'none' ? name : '',
//         sortDirection: _sortDirection,
//       });
//     }
//   };

//   const renderFieldInputComponent = ({ name, displayName, inputProps, isSortable, inputType }) => {
//     const _isSortable = isSortable && isSortingEnabled;
//     const _sortDirection = sortBy !== name ? 'none' : sortDirection;

//     const onLabelClick = () => {
//       handleFilterLabelClick(name);
//     };

//     const handleFieldChange = newValue => {
//       onValuesChange({
//         ...values,
//         [name]: newValue,
//       });
//     };

//     const handleDateRangeFieldChange = ({ startDate, endDate }) => {
//       onValuesChange({
//         ...values,
//         [name]: {
//           startDate: startDate,
//           endDate: endDate,
//         },
//       });
//     };

//     switch (inputType) {
//       case 'Text':
//         return (
//           <InputText
//             id={name}
//             key={name}
//             label={displayName}
//             isSortable={_isSortable}
//             sortDirection={_sortDirection}
//             onLabelClick={onLabelClick}
//             value={values[name]}
//             onChange={handleFieldChange}
//           />
//         );
//       case 'MultiSelect':
//         return (
//           <InputMultiSelect
//             id={name}
//             key={name}
//             label={displayName}
//             isSortable={_isSortable}
//             sortDirection={_sortDirection}
//             onLabelClick={onLabelClick}
//             value={values[name]}
//             onChange={handleFieldChange}
//             options={inputProps.options}
//           />
//         );
//       case 'DateRange':
//         return (
//           <InputDateRange
//             id={name}
//             key={name}
//             label={displayName}
//             isSortable={_isSortable}
//             sortDirection={_sortDirection}
//             onLabelClick={onLabelClick}
//             value={values[name]}
//             onChange={handleDateRangeFieldChange}
//           />
//         );
//       case 'None':
//         return (
//           <InputLabelWrapper
//             className="max-sm:hidden"
//             key={name}
//             label={displayName}
//             isSortable={_isSortable}
//             sortDirection={_sortDirection}
//             onLabelClick={onLabelClick}
//           />
//         );
//       default:
//         break;
//     }
//   };
//   return (
//     <div className="container mx-auto flex flex-col px-2 py-1">
//       <div className="flex flex-col gap-4 sm:flex-row">
//         {inputMeta.map((meta, index) => {
//           const isMobileHidden = !isExpanded && index > 0; // Solo ocultar si no está expandido y no es el primer input

//           return (
//             <div
//               key={meta.name}
//               className={classnames(
//                 'w-full sm:w-auto sm:pl-4',
//                 getGridWidthClass(meta.gridCol),
//                 isMobileHidden && 'max-sm:hidden' // Oculta solo en mobile si no está expandido
//               )}
//             >
//               {renderFieldInputComponent(meta)}
//             </div>
//           );
//         })}
//       </div>

//       {/* Mostrar botón solo en mobile y si hay más de un filtro */}
//       {inputMeta.length > 1 && (
//         <div className="mt-4 flex justify-center sm:hidden">
//           <button
//             onClick={() => setIsExpanded(prev => !prev)}
//             className="flex h-12 w-12 items-center justify-center rounded-full bg-green-700 text-white shadow-md transition hover:bg-green-600"
//           >
//             <Icons.ChevronDown
//               className={`transition-transform duration-300 ${
//                 isExpanded ? 'rotate-0' : 'rotate-180'
//               } text-2xl`}
//             />
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// InputGroup.propTypes = {
//   inputMeta: PropTypes.arrayOf(
//     PropTypes.shape({
//       name: PropTypes.string.isRequired,
//       displayName: PropTypes.string.isRequired,
//       inputType: PropTypes.oneOf(['Text', 'MultiSelect', 'DateRange', 'None']).isRequired,
//       isSortable: PropTypes.bool.isRequired,
//       gridCol: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).isRequired,
//       option: PropTypes.arrayOf(
//         PropTypes.shape({
//           value: PropTypes.string,
//           label: PropTypes.string,
//         })
//       ),
//     })
//   ).isRequired,
//   values: PropTypes.object.isRequired,
//   onValuesChange: PropTypes.func.isRequired,
//   sorting: PropTypes.shape({
//     sortBy: PropTypes.string,
//     sortDirection: PropTypes.oneOf(['ascending', 'descending', 'none']),
//   }).isRequired,
//   onSortingChange: PropTypes.func.isRequired,
//   isSortingEnabled: PropTypes.bool.isRequired,
// };

// export default InputGroup;
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import getGridWidthClass from '../../utils/getGridWidthClass';

import InputText from '../InputText';
import InputDateRange from '../InputDateRange';
import InputMultiSelect from '../InputMultiSelect';
import InputLabelWrapper from '../InputLabelWrapper';
import { Icons } from '@ohif/ui-next';

const InputGroup = ({
  inputMeta,
  values,
  onValuesChange,
  sorting,
  onSortingChange,
  isSortingEnabled,
}) => {
  const { sortBy, sortDirection } = sorting;
  const [isExpanded, setIsExpanded] = useState(false);

  const handleFilterLabelClick = name => {
    if (!isSortingEnabled) {
      return;
    }

    let _sortDirection = 'descending';
    if (sortBy === name) {
      _sortDirection = sortDirection === 'ascending' ? 'descending' : 'ascending';
    }

    onSortingChange({
      sortBy: _sortDirection !== 'none' ? name : '',
      sortDirection: _sortDirection,
    });
  };

  const renderFieldInputComponent = ({ name, displayName, inputProps, isSortable, inputType }) => {
    const _isSortable = isSortable && isSortingEnabled;
    const _sortDirection = sortBy !== name ? 'none' : sortDirection;

    const onLabelClick = () => handleFilterLabelClick(name);

    const handleFieldChange = newValue => {
      onValuesChange({
        ...values,
        [name]: newValue,
      });
    };

    const handleDateRangeFieldChange = ({ startDate, endDate }) => {
      onValuesChange({
        ...values,
        [name]: { startDate, endDate },
      });
    };
    switch (inputType) {
      case 'Text':
        return (
          <InputText
            key={name}
            id={name}
            label={displayName}
            isSortable={_isSortable}
            sortDirection={_sortDirection}
            onLabelClick={onLabelClick}
            value={values[name]}
            onChange={val => handleFieldChange(val?.toUpperCase())}
          />
        );
      case 'MultiSelect':
        return (
          <div key={name} className="flex flex-col xl:min-w-[284px]">
            <InputLabelWrapper
              label={displayName}
              isSortable={_isSortable}
              sortDirection={_sortDirection}
              onLabelClick={onLabelClick}
            />
            <div className="flex flex-wrap gap-2 mt-2">
              {inputProps.options.map((option: any) => {
                const isSelected = Array.isArray(values[name]) && values[name].includes(option.value);
                return (
                  <label key={option.value} className="flex items-center space-x-2 text-white cursor-pointer bg-black px-2 py-1 rounded border border-inputfield-main hover:border-inputfield-focus transition-colors">
                    <input
                      type="checkbox"
                      className="form-checkbox h-6 w-4 text-primary-active rounded bg-black border-inputfield-main"
                      checked={isSelected}
                      onChange={(e) => {
                        if (e.target.checked) {
                          // Solo permite uno seleccionado a la vez
                          handleFieldChange([option.value]);
                        } else {
                          // Deselecciona el actual
                          handleFieldChange([]);
                        }
                      }}
                    />
                    <span className="text-sm">{option.label}</span>
                  </label>
                );
              })}
            </div>
          </div>
        );
      case 'DateRange':
        return (
          <InputDateRange
            key={name}
            id={name}
            label={displayName}
            isSortable={_isSortable}
            sortDirection={_sortDirection}
            onLabelClick={onLabelClick}
            value={values[name]}
            onChange={handleDateRangeFieldChange}
          />
        );
      case 'None':
        return (
          <InputLabelWrapper
            key={name}
            className="max-sm:hidden"
            label={displayName}
            isSortable={_isSortable}
            sortDirection={_sortDirection}
            onLabelClick={onLabelClick}
          />
        );
      default:
        return null;
    }
  };
  return (
    <div className="bg-primary-dark overflow-hidden rounded-xl shadow-sm">
      {/* Campos de filtros */}
      <div className={'sm:px-6'}>
        <div className={classnames('grid grid-cols-1 gap-1 sm:grid-cols-4')}>
          {inputMeta.map((meta: any, index: number) => {
            const isMobileHidden = !isExpanded && index > 0;
            return (
              <div
                key={meta.name}
                className={classnames(
                  'transition-all duration-300',
                  meta.name === 'instances' ? 'hidden' : '',
                  getGridWidthClass(meta.gridCol),
                  isMobileHidden && 'max-sm:hidden'
                )}
              >
                {renderFieldInputComponent(meta)}
              </div>
            );
          })}
        </div>

        {/* Indicador de filtros ocultos */}
        {/* {inputMeta.length > 1 && !isExpanded && (
          <div className="mt-4 sm:hidden">
            <div className="flex items-center justify-center space-x-2 text-sm text-gray-300">
              <div className="flex space-x-1">
                {Array.from({ length: Math.min(3, inputMeta.length - 1) }, (_, i) => (
                  <div
                    key={i}
                    className="h-2 w-2 rounded-full bg-gray-300"
                  ></div>
                ))}
              </div>
            </div>
          </div>
        )} */}
        {/* Footer con estadísticas */}
        {/* <div className="my-3 border-t border-gray-200 bg-gray-50 pl-28 pt-3 text-xl text-white max-sm:hidden">
          <div className="flex items-end justify-end gap-4 text-xl sm:flex-row">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <div className="h-2 w-2 rounded-full bg-green-500"></div>
                <span className="text-gray-600">Filtros activos: 0</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="h-2 w-2 rounded-full bg-blue-500"></div>
                <span className="text-gray-600">Campos disponibles: {inputMeta.length}</span>
              </div>
            </div>
            <button className="font-medium text-blue-600 transition-colors hover:text-blue-700">
              Limpiar todo
            </button>

            {inputMeta.map((meta, index) => {
              const isMobileHidden = !isExpanded && index > 0;
              return (
                <div
                  key={meta.name}
                  className={classnames(
                    'transition-all duration-300',
                    getGridWidthClass(meta.gridCol),
                    isMobileHidden && 'max-sm:hidden'
                  )}
                >
                  <h4>{meta.displayName}</h4>
                </div>
              );
            })}
          </div>
        </div> */}
      </div>
    </div>
  );
};

InputGroup.propTypes = {
  inputMeta: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
      inputType: PropTypes.oneOf(['Text', 'MultiSelect', 'DateRange', 'None']).isRequired,
      isSortable: PropTypes.bool.isRequired,
      gridCol: PropTypes.number.isRequired,
      inputProps: PropTypes.object,
    })
  ).isRequired,
  values: PropTypes.object.isRequired,
  onValuesChange: PropTypes.func.isRequired,
  sorting: PropTypes.shape({
    sortBy: PropTypes.string,
    sortDirection: PropTypes.oneOf(['ascending', 'descending', 'none']),
  }).isRequired,
  onSortingChange: PropTypes.func.isRequired,
  isSortingEnabled: PropTypes.bool.isRequired,
};

export default InputGroup;
